export default "__VITE_PUBLIC_ASSET__b4da689d__"